import React from "react";
import { Link } from "react-router-dom";
import styles from "./style.module.css";

const Button = ({
  customClass = "",
  link,
  onClick,
  startIcon,
  endIcon,
  title,
  buttonType = "filled",
  buttonColor = "primary",
  disabled,
  onMouseEnter,
  onMouseLeave,
  ref,
  dataTour = "",
}) => {
  return (
    <div className={styles.button_wrapper}>
      {link ? (
        <Link
          to={link}
          className={`${styles.button} ${customClass} ${styles[buttonType]} ${styles[buttonColor]}`}
          onClick={onClick}
          disabled={disabled}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          ref={ref}
          data-tour={dataTour}
        >
          {startIcon && <span className={styles.start_icon}>{startIcon}</span>}
          <span className={styles.title}>{title}</span>
          {endIcon && <span className={styles.end_icon}>{endIcon}</span>}
        </Link>
      ) : (
        <button
          type="button"
          className={`${styles.button} ${customClass} ${styles[buttonType]} ${styles[buttonColor]}`}
          onClick={onClick}
          disabled={disabled}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          ref={ref}
          data-tour={dataTour}
        >
          {startIcon && <span className={styles.start_icon}>{startIcon}</span>}
          <span className={styles.title}>{title}</span>
          {endIcon && <span className={styles.end_icon}>{endIcon}</span>}
        </button>
      )}
    </div>
  );
};

export default Button;
